import React from "react";

export default function DisclaimerPage() {
  return (
    <div
      className="min-h-screen bg-[#FAFAF8] px-4 py-12"
      style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
    >
      <div className="max-w-2xl mx-auto">
        <h1 className="text-4xl tracking-[0.25em] uppercase font-light text-[#1A1A1A] mb-2">
          Arvay
        </h1>
        <p className="font-sans text-[10px] uppercase tracking-[0.25em] text-neutral-400 font-medium mb-12">
          Legal &amp; Content Discovery Disclaimer
        </p>

        <div className="space-y-10 font-sans text-sm text-[#1A1A1A] leading-relaxed">

          <section>
            <h2 className="text-base font-semibold uppercase tracking-wider mb-3">
              Nature of Service
            </h2>
            <p>
              Arvay (accessible via arvay.live and its mobile applications) operates strictly as a
              real-time data aggregation, discovery, and search utility workspace. The platform
              utilises public-facing syndication feeds (RSS), publicly accessible APIs (including
              GDELT), and user-defined search parameters to index, aggregate, and display metadata
              (including headlines, titles, publication attributions, and short informational text
              snippets).
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold uppercase tracking-wider mb-3">
              Non-Infringement &amp; Intellectual Property Compliance
            </h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-xs font-semibold uppercase tracking-wider text-neutral-500 mb-1.5">
                  External Link Routing
                </h3>
                <p>
                  Arvay does not host, replicate, or permanently store the full-text content of any
                  external news articles, publications, or premium digital assets on its servers.
                  Every article card or search result served on this platform acts solely as a
                  directional pointer. Clicking a headline or link routes the user via a direct
                  external hyperlink to the original publisher's domain.
                </p>
              </div>
              <div>
                <h3 className="text-xs font-semibold uppercase tracking-wider text-neutral-500 mb-1.5">
                  Respect for Premium Paywalls
                </h3>
                <p>
                  Arvay strictly respects the digital rights management and paywall structures of
                  premium content publishers (including, but not limited to, Bloomberg, Financial
                  Times, and similar institutions). The platform does not attempt, deploy, or utilise
                  any code, scripts, or proxies designed to bypass, scrape, or circumvent premium
                  subscription gates or user paywalls. Arvay displays only the basic informational
                  metadata made publicly available by the respective publishers' syndication channels.
                </p>
              </div>
              <div>
                <h3 className="text-xs font-semibold uppercase tracking-wider text-neutral-500 mb-1.5">
                  Ownership
                </h3>
                <p>
                  All trademarks, logos, brand names, publication titles, and intellectual property
                  displayed within the source cards belong entirely to their respective original
                  copyright holders. Attribution is prominently displayed on every asset card to
                  maintain source integrity.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-base font-semibold uppercase tracking-wider mb-3">
              DMCA &amp; Copyright Infringement Notice (Safe Harbour)
            </h2>
            <p>
              Arvay operates under the safe harbour protections of global digital regulations,
              including Section 512 of the Digital Millennium Copyright Act (DMCA) and Section 79
              of the Information Technology Act (India). We maintain a strict zero-tolerance policy
              for copyright violations.
            </p>
            <p className="mt-3">
              If you are a copyright owner or an authorised agent thereof and believe that any
              metadata link or snippet indexed on this platform infringes upon your rights, please
              submit a formal takedown request containing the specific source URLs to our legal desk
              at{" "}
              <a
                href="mailto:support@arvay.live"
                className="underline hover:text-black transition-colors"
              >
                support@arvay.live
              </a>
              . Valid requests will be processed and removed immediately within 24 to 48 business
              hours.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold uppercase tracking-wider mb-3">
              Age Restriction
            </h2>
            <p>
              Arvay is restricted to users aged 17 and above. The platform aggregates news, financial
              data, and community content that may include mature or complex themes not suitable for
              younger audiences. By creating an account and using this service, you confirm that you
              are at least 17 years of age.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold uppercase tracking-wider mb-3">
              No Financial or Investment Advice
            </h2>
            <p>
              The numerical data, indices, market cards, and crypto trackers displayed on Arvay
              (sourced via third-party APIs including Yahoo Finance and CoinGecko) are provided
              strictly for general informational, educational, and macro-monitoring purposes. Arvay
              is not a registered financial advisor, broker, or institutional asset desk. No
              information or search result generated by this platform constitutes financial, legal,
              tax, or investment advice. Users must conduct independent due diligence before
              executing any market-related transactions.
            </p>
          </section>

        </div>

        <div className="mt-12 pt-6 border-t border-[#E0E0E0]">
          <a
            href="/"
            className="font-sans text-[10px] uppercase tracking-[0.18em] font-semibold text-neutral-500 hover:text-black transition-colors"
          >
            ← Back to Arvay
          </a>
          <p className="font-sans text-[9px] text-neutral-300 mt-4">Last Updated: September 2026</p>
        </div>
      </div>
    </div>
  );
}
